<template>
  <div class="ability-detail">
    <h4 class="page-title my-3">{{ ruleForm.id ? '编辑' : '新增' }}能力框架</h4>
    <el-card>
      <h4 class="card-title mb-3">图谱详情</h4>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="configure-form">
        <el-form-item label="能力框架名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          v-for="(target, index) in ruleForm.list"
          :label="'L' + (index + 1)"
          :key="target.key"
          class="form-item-border"
        >
          <el-form-item class="form-item-target-name" label="指标名称">
            <el-input v-model="target.indicator_name"></el-input>
            <el-button class="btn-remove" type="text" @click="removeTarget(target)">删除</el-button>
          </el-form-item>
          <el-form-item label="指标描述">
            <el-input class="mb-2" type="textarea" v-model="target.description"></el-input>
          </el-form-item>
          <el-form-item label="评价指标">
            <el-select
              style="width: 100%"
              v-model="target.level_id"
              placeholder="请选择评价指标"
              @change="(val) => handleChangeLevel(val, index)"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, _index) in evaluateList"
                :key="_index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指标评语">
            <div class="flex comment-wrapper mb-2" v-for="(comment, _index) in target.content" :key="_index">
              <div class="flex-left">
                {{ comment.tier }}、{{ comment.max }}~{{ comment.min
                }}<template v-if="comment.alias">({{ comment.alias }})</template>
              </div>
              <div class="flex-right">
                <el-input v-model="comment.evaluation" placeholder="请输入内容"></el-input>
              </div>
            </div>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="addTarget">新增指标</el-button>
          <!-- <div class="text-small">注意：不启用的指标请留空</div> -->
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button type="primary" plain size="medium" @click="handleBack">返回</el-button>
        <el-button type="primary" size="medium" @click="submitForm">保存</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      rules: {},
      evaluateList: [], // 评价指标列表
      ruleForm: {
        id: 0,
        is_share: 1,
        name: '',
        list: [],
      },
    }
  },
  mounted() {
    let id = this.$route.params.id
    this.ruleForm.id = Number(id)
    if (this.ruleForm.id) {
      this.getCapabilityFrameDetail()
    }
    this.getCapabilityConfiguration()
  },
  methods: {
    getCapabilityFrameDetail() {
      this.$store
        .dispatch('capability/getCapabilityFrameDetail', this.ruleForm.id)
        .then((res) => {
          console.log('getCapabilityFrameDetail:', res)
          if (res.code === 1) {
            this.ruleForm = res.data
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    getCapabilityConfiguration() {
      this.$store
        .dispatch('capability/getCapabilityConfiguration')
        .then((res) => {
          console.log('getCapabilityConfiguration:', res)
          if (res.code === 1) {
            this.evaluateList = res.data
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 评价指标联动指标评语
    handleChangeLevel(val, index) {
      this.ruleForm.list[index].content =
        this.evaluateList
          .find((item) => item.id === val)
          ?.content.map((_) => {
            return {
              ..._,
              evaluation: _.default || '',
            }
          }) || []
    },
    // 提交表单
    async submitForm() {
      let params = {
        id: this.ruleForm.id,
        name: this.ruleForm.name,
        list: this.ruleForm.list.map((item) => {
          return {
            indicator_name: item.indicator_name,
            description: item.description,
            level_id: item.level_id,
            content: item.content.map((_) => {
              return {
                tier: _.tier,
                evaluation: _.evaluation,
              }
            }),
          }
        }),
      }
      this.$store
        .dispatch(`capability/${params.id ? 'editCapabilityFrame' : 'addCapabilityFrame'}`, params)
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$message.success('保存成功')
            this.handleBack()
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    removeTarget(item) {
      var index = this.ruleForm.list.indexOf(item)
      if (index !== -1) {
        this.ruleForm.list.splice(index, 1)
      }
    },
    addTarget() {
      this.ruleForm.list.push({
        indicator_name: '',
        description: '',
        level_id: this.evaluateList[0].id,
        content: [],
        key: Date.now(),
      })
      this.handleChangeLevel(this.evaluateList[0].id, this.ruleForm.list.length - 1)
    },
    handleBack() {
      this.$router.push({
        path: this.$route.query.courseId ? `/ability-graph/detail/configure?courseId=${this.$route.query.courseId}` : '/ability-framework/index',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-detail {
  .page-title {
    font-weight: 600;
  }
  .card-title {
    color: #343a40;
    font-weight: bold;
  }
  .text-small {
    font-size: 13px;
    color: #6c757d;
  }
  .font-bold {
    font-weight: bold;
  }
  ::v-deep {
    .el-form-item__label {
      font-size: 14px;
      color: #6c757d;
      font-weight: 500;
    }
  }
  .form-item-border {
    border-bottom: 1px solid #e6e6e6;
    ::v-deep {
      .el-form-item__content {
        .el-form-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          &__label {
            text-align: left !important;
            width: 100% !important;
            display: block;
          }
          &__content {
            margin-left: 0 !important;
          }
        }
      }
      .form-item-target-name {
        position: relative;
        .btn-remove {
          font-size: 14px;
          color: #e53939;
          position: absolute;
          top: -44px;
          right: 0;
        }
      }
    }
  }
  .comment-wrapper {
    .flex-left {
      width: 120px;
    }
    .flex-right {
      width: 0;
      flex: 1;
    }
  }
}
</style>
